import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import { StylesProvider } from '@rexlabs/styling';
import SplitButton from './';
import OutlineButton from '../basic/outline';
import OutlineIconButton from '../icon/outline';
var tokens = {
  button: {
    split: {
      divider: {
        background: {
          color: function color(_ref) {
            var token = _ref.token;
            return token('color.border.primary.idle.default');
          }
        }
      }
    }
  }
};

function OutlineSplitButton(props) {
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(SplitButton, _extends({
    Button: OutlineButton,
    IconButton: OutlineIconButton
  }, props)));
}

export default OutlineSplitButton;